import { useState } from "react";
import Button from "../../shared/components/ui/Buttons";
import Modal from "../../shared/components/ui/Modal";
import Carousel from "../../shared/components/ui/Carousel";
import { InfoCard } from "../../shared/components/ui/Cards";

function TestPage2() {
  const [activeModal, setActiveModal] = useState(null);

  const handleClose = () => {
    setActiveModal(null);
  };

  const handleConfirm = () => {
    console.log("Confirmed modal action");
    handleClose();
  };

  const longContent = Array.from({ length: 24 }, (_, index) => (
    <p className="u-type-body" key={index}>
      This is overflow test paragraph {index + 1}. It helps confirm that the
      modal body scrolls internally while the modal header and footer remain
      visible.
    </p>
  ));


  // =========== CAROUSEL ===================
  const carouselItems = [
    {
      id: "technology",
      eyebrow: "Technology",
      title: "Digital Systems",
      description: "Building software platforms, dashboards, and automation tools.",
    },
    {
      id: "engineering",
      eyebrow: "Engineering",
      title: "Technical Solutions",
      description: "Supporting infrastructure, systems design, and implementation.",
    },
    {
      id: "investment",
      eyebrow: "Investment",
      title: "Strategic Growth",
      description: "Developing scalable companies across high-impact sectors.",
    },
  ];

  // =========== END CAROUSEL ===================

  return (
    <section className="l-section l-section--base test-page">
      <div className="l-container l-container--max">
        <div className="l-stack l-stack--lg">
          <div className="l-stack l-stack--sm">
            <span className="u-eyebrow">Modal Test</span>
            <h1 className="u-type-page-title">Modal Placement Preview</h1>
            <p className="u-type-intro l-measure">
              Test center, left drawer, right drawer, top alert, bottom sheet,
              full-width modal, and overflow scrolling behavior.
            </p>
          </div>

          <div className="l-cluster l-cluster--spaced">
            <Button onClick={() => setActiveModal("center")}>
              Center Modal
            </Button>

            <Button variant="outline" onClick={() => setActiveModal("left")}>
              Left Drawer
            </Button>

            <Button variant="outline" onClick={() => setActiveModal("right")}>
              Right Drawer
            </Button>

            <Button variant="outline" onClick={() => setActiveModal("top")}>
              Top Modal
            </Button>

            <Button variant="outline" onClick={() => setActiveModal("bottom")}>
              Bottom Sheet
            </Button>

            <Button variant="secondary" onClick={() => setActiveModal("full")}>
              Full Modal
            </Button>

            <Button
              variant="ghost"
              onClick={() => setActiveModal("scroll-center")}
            >
              Scroll Center
            </Button>

            <Button
              variant="ghost"
              onClick={() => setActiveModal("scroll-drawer")}
            >
              Scroll Drawer
            </Button>

            <Button
              variant="ghost"
              onClick={() => setActiveModal("scroll-bottom")}
            >
              Scroll Bottom
            </Button>
          </div>

          <Modal
            isOpen={activeModal === "center"}
            onClose={handleClose}
            title="Center Modal"
            description="This modal should appear centered on the page."
            placement="center"
            size="md"
            footer={
              <>
                <Button variant="ghost" onClick={handleClose}>
                  Cancel
                </Button>

                <Button variant="primary" onClick={handleConfirm}>
                  Confirm
                </Button>
              </>
            }
          >
            <p className="u-type-body">
              This is the standard centered modal placement for confirmations,
              forms, and focused content.
            </p>
          </Modal>

          <Modal
            isOpen={activeModal === "left"}
            onClose={handleClose}
            title="Left Drawer"
            description="This modal behaves like a left-side drawer."
            placement="left"
            size="sm"
          >
            <div className="l-stack l-stack--sm">
              <p className="u-type-body">
                Use this placement for filters, navigation panels, or side
                controls.
              </p>

              <p className="u-type-body">
                It should attach to the left side and stretch vertically within
                the overlay padding.
              </p>
            </div>
          </Modal>

          <Modal
            isOpen={activeModal === "right"}
            onClose={handleClose}
            title="Right Drawer"
            description="This modal behaves like a right-side drawer."
            placement="right"
            size="sm"
          >
            <div className="l-stack l-stack--sm">
              <p className="u-type-body">
                Use this placement for contact forms, quick views, or detail
                panels.
              </p>

              <p className="u-type-body">
                It should attach to the right side and stretch vertically within
                the overlay padding.
              </p>
            </div>
          </Modal>

          <Modal
            isOpen={activeModal === "top"}
            onClose={handleClose}
            title="Top Modal"
            description="This modal appears near the top of the screen."
            placement="top"
            size="md"
          >
            <p className="u-type-body">
              Use this for alerts, announcements, or compact global messages.
            </p>
          </Modal>

          <Modal
            isOpen={activeModal === "bottom"}
            onClose={handleClose}
            title="Bottom Sheet"
            description="This modal appears near the bottom of the screen."
            placement="bottom"
            size="md"
            footer={
              <>
                <Button variant="ghost" onClick={handleClose}>
                  Dismiss
                </Button>

                <Button variant="primary" onClick={handleConfirm}>
                  Continue
                </Button>
              </>
            }
          >
            <div className="l-stack l-stack--sm">
              <p className="u-type-body">
                Use this for mobile-style quick actions or bottom sheet
                patterns.
              </p>

              <p className="u-type-body">
                The modal should sit at the bottom without taking unnecessary
                vertical height.
              </p>
            </div>
          </Modal>

          <Modal
            isOpen={activeModal === "full"}
            onClose={handleClose}
            title="Full Width Modal"
            description="This modal gives more room for detailed content."
            placement="center"
            size="full"
          >
            <div className="l-stack l-stack--sm">
              <p className="u-type-body">
                Use this for project previews, large forms, media previews, or
                structured detail views.
              </p>

              <p className="u-type-body">
                The full modal still stays within the screen and keeps the body
                scrollable.
              </p>
            </div>
          </Modal>

          <Modal
            isOpen={activeModal === "scroll-center"}
            onClose={handleClose}
            title="Scrollable Center Modal"
            description="The modal should stay within the viewport while the body scrolls."
            placement="center"
            size="md"
            footer={
              <>
                <Button variant="ghost" onClick={handleClose}>
                  Cancel
                </Button>

                <Button variant="primary" onClick={handleConfirm}>
                  Confirm
                </Button>
              </>
            }
          >
            <div className="l-stack l-stack--sm">{longContent}</div>
          </Modal>

          <Modal
            isOpen={activeModal === "scroll-drawer"}
            onClose={handleClose}
            title="Scrollable Right Drawer"
            description="The drawer should stay fixed while the body scrolls internally."
            placement="right"
            size="sm"
            footer={
              <>
                <Button variant="ghost" onClick={handleClose}>
                  Cancel
                </Button>

                <Button variant="primary" onClick={handleConfirm}>
                  Save
                </Button>
              </>
            }
          >
            <div className="l-stack l-stack--sm">{longContent}</div>
          </Modal>

          <Modal
            isOpen={activeModal === "scroll-bottom"}
            onClose={handleClose}
            title="Scrollable Bottom Sheet"
            description="The bottom sheet should stay within the viewport while the body scrolls."
            placement="bottom"
            size="md"
            footer={
              <>
                <Button variant="ghost" onClick={handleClose}>
                  Dismiss
                </Button>

                <Button variant="primary" onClick={handleConfirm}>
                  Continue
                </Button>
              </>
            }
          >
            <div className="l-stack l-stack--sm">{longContent}</div>
          </Modal>
        </div>
      </div>

      <section className="l-section l-section--base ">
        <div className="l-container l-container--max ">
          <h1 className="u-type-page-title ">Carousel System</h1>
          <br />
          <Carousel
            items={carouselItems}
            slidesPerView={1}
            showControls
            showDots
            infinite
            renderItem={(item) => (
              <InfoCard
                eyebrow={item.eyebrow}
                title={item.title}
                description={item.description}
                variant="default"
                hoverable
                fullHeight
              />
            )}
          />
          </div>

      </section>
    </section>
  );
}

export default TestPage2;